import {
	Collapse,
	createStyles,
	Group,
	Stack,
	UnstyledButton,
} from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { stripMarkdownLinks } from '@repo/common/utils';
import { Icon, Text } from '@repo/foundations';
import { memo } from 'react';
import { Link } from 'react-router';
import type { ISecodaEntity } from '../../../api';

const useStyles = createStyles((theme) => ({
	wrapper: {
		borderRadius: theme.radius.md,
		boxShadow: theme.shadows.sm,
		backgroundColor: theme.other.getColor('surface/primary/default'),
		width: '100%',
	},
	toggleButton: {
		padding: `${theme.spacing.sm} ${theme.spacing.md}`,
	},
	content: {
		padding: `0 ${theme.spacing.xs} ${theme.spacing.xs} ${theme.spacing.xs}`,
	},
	question: {
		padding: `${theme.spacing['2xs']} ${theme.spacing.xs}`,
		borderRadius: theme.radius.sm,
		backgroundColor: theme.other.getColor('surface/transparent/default'),

		'&:hover': {
			backgroundColor: theme.other.getColor('surface/transparent/hover'),
		},
	},
}));

export const RelatedQuestions = memo(
	({
		relatedQuestions,
		onClickQuestion,
	}: {
		relatedQuestions: ISecodaEntity[];
		onClickQuestion: () => void;
	}) => {
		const { classes } = useStyles();
		const [opened, { toggle }] = useDisclosure(true);

		return (
			<Stack spacing={0} className={classes.wrapper}>
				<UnstyledButton onClick={toggle} className={classes.toggleButton}>
					<Group spacing="3xs" position="apart">
						<Text size="sm" weight="semibold">
							Similar questions
						</Text>
						<Icon name={opened ? 'chevronUp' : 'chevronDown'} />
					</Group>
				</UnstyledButton>
				<Collapse in={opened}>
					<Stack spacing={0} className={classes.content}>
						{relatedQuestions.map((question) => (
							<UnstyledButton
								component={Link}
								to={`/questions/${question.id}`}
								key={question.id}
								className={classes.question}
								onClick={onClickQuestion}
							>
								<Text size="sm" truncate>
									{stripMarkdownLinks(question.title)}
								</Text>
							</UnstyledButton>
						))}
					</Stack>
				</Collapse>
			</Stack>
		);
	}
);
